export default {"src":"/_next/static/media/id-note-logo.76bcbdd7.svg","height":34,"width":38,"blurWidth":0,"blurHeight":0};